(()=>{const body=document.body;let view='designs';try{view=JSON.parse(localStorage.getItem('retromaha-tee-view'))==='full'?'full':'designs'}catch{}
function sync(){body.classList.toggle('rm-full-tees',view==='full');document.querySelectorAll('[data-rm-card-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.rmCardView===view)));document.querySelectorAll('[data-rm-view-hint]').forEach(p=>{const text=view==='full'?p.dataset.fullHint:p.dataset.designHint;if(p.textContent!==text)p.textContent=text})}
sync();document.addEventListener('click',e=>{const button=e.target.closest('[data-rm-card-view]');if(button){view=button.dataset.rmCardView;try{localStorage.setItem('retromaha-tee-view',JSON.stringify(view))}catch{}sync();const home=document.querySelector('#rm-design-home [data-view="'+view+'"]');if(home&&home.getAttribute('aria-pressed')!=='true')home.click()}
const homeButton=e.target.closest('#rm-design-home [data-view]');if(homeButton){view=homeButton.dataset.view;sync()}
const galleryButton=e.target.closest('[data-rm-gallery-view]');if(galleryButton){const wrap=galleryButton.closest('.product__media-wrapper');wrap.classList.toggle('rm-gallery-design',galleryButton.dataset.rmGalleryView==='designs');wrap.querySelectorAll('[data-rm-gallery-view]').forEach(b=>b.setAttribute('aria-pressed',String(b===galleryButton)))}
});new MutationObserver(()=>sync()).observe(document.getElementById('MainContent'),{childList:true,subtree:true});document.addEventListener('shopify:section:load',sync);window.addEventListener('storage',e=>{if(e.key==='retromaha-tee-view'){try{view=JSON.parse(e.newValue)==='full'?'full':'designs'}catch{}sync()}})})();

/* Use actual mouse/pen entry, including computers with touch screens. */
(()=>{const selector='#rm-design-home .card,.rm-tee-card,.product__media-wrapper:has(.rm-gallery-tools) .product__media';
function update(e,on){if(e.pointerType==='touch')return;const card=e.target.closest(selector);if(!card||card.contains(e.relatedTarget))return;card.classList.toggle('rm-pointer-over',on)}
document.addEventListener('pointerover',e=>update(e,true));document.addEventListener('pointerout',e=>update(e,false));
window.addEventListener('blur',()=>document.querySelectorAll('.rm-pointer-over').forEach(c=>c.classList.remove('rm-pointer-over')));
})();
(()=>{
const seen=new WeakSet(),cache=new Map(),preloads=new Map();
function previewSource(src){if(!src)return src;const u=new URL(src,location.origin);if(u.hostname==='cdn.shopify.com'&&u.pathname.includes('/files/')){const path=u.pathname.slice(u.pathname.lastIndexOf('/files/')+7);u.href=location.origin+'/cdn/shop/files/'+path+u.search}u.searchParams.set('width','1000');return u.href}
function preload(src){if(!src)return Promise.resolve(false);if(!preloads.has(src)){preloads.set(src,new Promise(resolve=>{const i=new Image();i.decoding='async';i.onload=()=>{if(i.decode)i.decode().then(()=>resolve(true),()=>resolve(true));else resolve(true)};i.onerror=()=>resolve(false);i.src=src}))}return preloads.get(src)}
const selector='#rm-design-home .card,.rm-tee-card';
async function load(card){
if(seen.has(card))return;seen.add(card);
const link=card.querySelector('.image-link,.rm-card-media-link,a[href*="/products/"]');
if(!link)return;
const url=new URL(link.href,location.origin);const match=url.pathname.match(/\/products\/([^/]+)/);if(!match)return;
try{
if(!cache.has(match[1]))cache.set(match[1],fetch('/products/'+encodeURIComponent(match[1])+'.js').then(r=>{if(!r.ok)throw Error('Product unavailable');return r.json()}));
const p=await cache.get(match[1]);const pos=p.options.findIndex(o=>/colou?r/i.test(typeof o==='string'?o:o.name));if(pos<0)return;
const colors=new Map();p.variants.forEach(v=>{if(v.available){const name=v.options[pos];if(!colors.has(name)||(!colors.get(name).featured_image&&v.featured_image))colors.set(name,v)}});
if(colors.size<2)return;
const box=document.createElement('div');box.className='rm-color-swatches';box.setAttribute('role','group');box.setAttribute('aria-label','Available tee colors');
const image=card.querySelector('.product-img,.card__media .media>img:first-child');if(!image)return;
let current=image.currentSrc||image.src;
const originalSrcset=image.getAttribute('srcset'),originalAlt=image.alt;
let selectedAlt=originalAlt,selected=false;
let previewRequest=0,pointerInBox=false;
const show=async(src,alt,restoreSet=false)=>{const request=++previewRequest;if(image.src!==src&&!(await preload(src)))return;if(request!==previewRequest||!image.isConnected)return;if(image.src!==src||image.hasAttribute('srcset')){image.removeAttribute('srcset');if(image.src!==src)image.src=src}image.alt=alt;if(restoreSet&&originalSrcset&&image.getAttribute('srcset')!==originalSrcset)image.setAttribute('srcset',originalSrcset)};
const restore=()=>show(current,selectedAlt,!selected);
box.addEventListener('pointerenter',()=>{pointerInBox=true});
box.addEventListener('pointerleave',()=>{pointerInBox=false;restore()});
colors.forEach((v,name)=>{
const b=document.createElement('button');b.type='button';b.className='rm-color-swatch';b.title=name;b.setAttribute('aria-label','Preview '+name);b.setAttribute('aria-pressed','false');
const img=previewSource(v.featured_image?.src);preload(img);const dot=document.createElement('span');
if(img){dot.style.backgroundImage='url("'+img.replaceAll('"','%22')+'")';dot.style.backgroundSize='650%';dot.style.backgroundPosition='40% 75%'}else{dot.style.backgroundColor=CSS.supports('color',name)?name:'#888'}
b.append(dot);b.addEventListener('pointerenter',e=>{if(e.pointerType!=='touch'&&img)show(img,p.title+' — '+name)});b.addEventListener('focus',()=>{if(img)show(img,p.title+' — '+name)});b.addEventListener('blur',()=>{if(!pointerInBox)restore()});b.addEventListener('click',e=>{
e.preventDefault();e.stopPropagation();if(!img){location.href=url.pathname+'?variant='+v.id;return}
selected=true;current=img;selectedAlt=p.title+' — '+name;show(current,selectedAlt);
box.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));
card.querySelectorAll('a[href*="/products/"]').forEach(a=>{a.href=url.pathname+'?variant='+v.id});
});box.append(b);
});
card.append(box);
const holder=card.querySelector('.image-link,.card__inner');const place=()=>{box.style.top=Math.max(0,holder.getBoundingClientRect().bottom-card.getBoundingClientRect().top-box.offsetHeight-8)+'px'};
new ResizeObserver(place).observe(holder);place();
}catch{}
}
const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){io.unobserve(e.target);const image=e.target.querySelector('.product-img,.card__media img');if(image&&!image.complete)image.addEventListener('load',()=>load(e.target),{once:true});else load(e.target)}}),{rootMargin:'150px'});
const scan=()=>document.querySelectorAll(selector).forEach(c=>{if(!seen.has(c))io.observe(c)});
const start=()=>{if('requestIdleCallback' in window)requestIdleCallback(scan,{timeout:1500});else setTimeout(scan,0)};if(document.readyState==='complete')start();else window.addEventListener('load',start,{once:true});new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.(selector)||n.querySelector?.(selector)))))scan()}).observe(document.getElementById('MainContent'),{childList:true,subtree:true});
})();

(()=>{
function detectGraphic(data, width, height) {
  if (width / height < 0.85 || width / height > 1.15) return null;
  const pixel = (x, y, c) => data[(y * width + x) * 4 + c];
  const median = values => values.sort((a, b) => a - b)[Math.floor(values.length / 2)];
  const distance = (x, y, base) => Math.sqrt(base.reduce((sum, value, c) => sum + (pixel(x, y, c) - value) ** 2, 0));
  const corners = [0, 1, 2].map(c => median([pixel(3, 3, c), pixel(width - 4, 3, c), pixel(3, height - 4, c), pixel(width - 4, height - 4, c)]));
  const cornerSpread = [[3, 3], [width - 4, 3], [3, height - 4], [width - 4, height - 4]].reduce((max, p) => Math.max(max, distance(...p, corners)), 0);
  if (cornerSpread > 32) return null;
  const x0 = Math.round(width * 0.29), x1 = Math.round(width * 0.71);
  const y0 = Math.round(height * 0.24), y1 = Math.round(height * 0.68);
  const weights = new Float32Array(width * height);
  let count = 0;
  for (let y = y0; y < y1; y++) {
    const base = [0, 1, 2].map(c => {
      const values = [];
      for (let x = Math.round(width * 0.265); x < Math.round(width * 0.32); x++) values.push(pixel(x, y, c));
      for (let x = Math.round(width * 0.68); x < Math.round(width * 0.735); x++) values.push(pixel(x, y, c));
      return median(values);
    });
    for (let x = x0; x < x1; x++) {
      const diff = distance(x, y, base);
      if (diff > 32) { weights[y * width + x] = Math.min(90, diff - 24); count++; }
    }
  }
  if (count < width * height * 0.002 || count > (x1 - x0) * (y1 - y0) * 0.55) return null;
  const columns = new Float32Array(width), rows = new Float32Array(height);
  let total = 0;
  for (let y = y0 + 1; y < y1 - 1; y++) for (let x = x0 + 1; x < x1 - 1; x++) {
    const index = y * width + x, weight = weights[index];
    if (!weight) continue;
    let neighbors = 0;
    for (let dy = -1; dy <= 1; dy++) for (let dx = -1; dx <= 1; dx++) if (weights[index + dy * width + dx]) neighbors++;
    if (neighbors < 4) continue;
    columns[x] += weight; rows[y] += weight; total += weight;
  }
  if (total < width * height * 0.18) return null;
  const quantile = (values, fraction) => { let sum = 0; for (let i = 0; i < values.length; i++) { sum += values[i]; if (sum >= total * fraction) return (i + 0.5) / values.length; } return 0.5; };
  const left = quantile(columns, 0.04), right = quantile(columns, 0.96);
  const top = quantile(rows, 0.04), bottom = quantile(rows, 0.96);
  if (right - left < 0.035 || bottom - top < 0.018 || bottom - top > 0.38) return null;
  return { x: (left + right) / 2, y: (top + bottom) / 2, width: right - left, height: bottom - top };
}


const selector = '#rm-design-home .card .product-img,.rm-tee-card .card__media .media>img:first-child,#rm-wall-dialog .rm-wall-tile img';
const storageKey = 'retromaha-graphic-centers-v2';
const cache = new Map(), pending = new Map(), queued = new Set(), watched = new WeakSet();
let active = 0, saveTimer;
try {
  const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
  if (Array.isArray(saved)) saved.slice(-400).forEach(([key, point]) => {
    if (typeof key === 'string' && (point === null || (Number.isFinite(point?.x) && Number.isFinite(point?.y) && point.x >= 0.2 && point.x <= 0.8 && point.y >= 0.2 && point.y <= 0.7))) cache.set(key, point);
  });
} catch {}
const source = image => image.currentSrc || image.src;
function urls(src) {
  const url = new URL(src, location.href);
  if (!['https:', 'http:'].includes(url.protocol)) throw Error('Unsupported image');
  ['width', 'height', 'crop', 'format'].forEach(key => url.searchParams.delete(key));
  const key = url.href;
  url.searchParams.set('width', '160');
  return {key, thumbnail: url.href};
}
function remember(key, point) {
  cache.set(key, point);
  while (cache.size > 400) cache.delete(cache.keys().next().value);
  clearTimeout(saveTimer);
  saveTimer = setTimeout(() => { try { localStorage.setItem(storageKey, JSON.stringify([...cache])); } catch {} }, 250);
}
function analyze(thumbnail) {
  return new Promise(resolve => {
    const image = new Image();
    let finished = false;
    const done = point => { if (finished) return; finished = true; clearTimeout(timer); image.onload = image.onerror = null; resolve(point); };
    const timer = setTimeout(() => done(null), 2500);
    image.crossOrigin = 'anonymous';
    image.decoding = 'async';
    image.onerror = () => done(null);
    image.onload = () => {
      try {
        if (image.naturalWidth / image.naturalHeight < 0.85 || image.naturalWidth / image.naturalHeight > 1.15) return done(null);
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = 160;
        const context = canvas.getContext('2d', {willReadFrequently: true});
        context.fillStyle = '#fff'; context.fillRect(0, 0, 160, 160);
        context.drawImage(image, 0, 0, 160, 160);
        done(detectGraphic(context.getImageData(0, 0, 160, 160).data, 160, 160));
      } catch { done(null); }
    };
    image.src = thumbnail;
  });
}
async function center(image) {
  if (!image.isConnected || !image.complete || !image.naturalWidth) return;
  const link = image.closest('a');
  if (/hoodie|mug/i.test(link?.href || '')) { image.dataset.rmGraphicCenter = 'fallback'; return; }
  const src = source(image);
  try {
    const {key, thumbnail} = urls(src);
    let point;
    if (cache.has(key)) point = cache.get(key);
    else {
      if (!pending.has(key)) pending.set(key, analyze(thumbnail).then(result => {remember(key, result); pending.delete(key); return result;}));
      point = await pending.get(key);
    }
    if (!image.isConnected || source(image) !== src) return;
    image.dataset.rmGraphicCenter = point ? `${point.x.toFixed(4)},${point.y.toFixed(4)}` : 'fallback';
    if (point) {
      const zoom = 2.25;
      image.style.removeProperty('--zoom');
      const origin = value => Math.max(0, Math.min(100, ((zoom * value - 0.5) / (zoom - 1)) * 100));
      image.style.setProperty('transform-origin', `${origin(point.x).toFixed(2)}% ${origin(point.y).toFixed(2)}%`);
    }
  } catch { image.dataset.rmGraphicCenter = 'fallback'; }
}
function pump() {
  while (active < 2 && queued.size) {
    const image = queued.values().next().value;
    queued.delete(image); active++;
    const run = () => center(image).finally(() => {active--; pump();});
    if ('requestIdleCallback' in window) requestIdleCallback(run, {timeout: 600}); else setTimeout(run, 0);
  }
}
const observer = new IntersectionObserver(entries => entries.forEach(entry => {
  if (entry.isIntersecting) { observer.unobserve(entry.target); queued.add(entry.target); pump(); }
}), {rootMargin: '250px'});
function watch(image) {
  if (!watched.has(image)) {
    watched.add(image);
    image.addEventListener('load', () => observer.observe(image));
  }
  if (image.complete && image.naturalWidth) {
    try { if (cache.has(urls(source(image)).key)) { center(image); return; } } catch {}
  }
  observer.observe(image);
}
function scan(root) {
  if (root.nodeType !== 1 && root.nodeType !== 9) return;
  if (root.matches?.(selector)) watch(root);
  root.querySelectorAll(selector).forEach(watch);
}
scan(document);
new MutationObserver(records => records.forEach(record => {
  if (record.type === 'childList') record.addedNodes.forEach(scan);
  else if (record.target.matches(selector)) {
    // Keep the current crop until the replacement image has a measured crop.
    delete record.target.dataset.rmGraphicCenter;
    observer.observe(record.target);
  }
})).observe(document.getElementById('MainContent') || document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset']});

})();

(()=>{
const root=document.getElementById('rm-design-home');
if(!root||root.classList.contains('rm-wall-page'))return;
const trigger=root.querySelector('.rm-wall-button');
if(!trigger)return;
trigger.setAttribute('aria-haspopup','dialog');
trigger.textContent=trigger.textContent.replace('↗','').trim();
let dialog,wall,loaded=false,previousOverflow='',cycle=[];
function extendWall(){
  if(!dialog?.open||!cycle.length||dialog.scrollHeight-dialog.clientHeight-dialog.scrollTop>dialog.clientHeight*2)return;
  const fragment=document.createDocumentFragment();
  cycle.forEach(tile=>fragment.append(tile.cloneNode(true)));
  wall.append(fragment);
}
const seen=new Set();
function add(tees){
  const fragment=document.createDocumentFragment();
  tees.forEach(tee=>{
    if(!tee.image||seen.has(tee.id))return;
    seen.add(tee.id);
    const link=document.createElement('a');
    link.className='rm-wall-tile';link.href=tee.url;link.setAttribute('aria-label','View '+tee.name);
    const image=document.createElement('img');
    image.src=tee.image;image.alt=tee.name;image.width=image.height=1000;image.loading='lazy';image.decoding='async';
    const details=document.createElement('span');details.className='rm-wall-details';
    const name=document.createElement('strong');name.textContent=tee.name;
    const price=document.createElement('span');price.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(tee.price/100);
    details.append(name,price);link.append(image,details);fragment.append(link);
  });
  wall.append(fragment);
}
async function load(){
  if(loaded)return;
  loaded=true;
  try{
    add(JSON.parse(root.querySelector('[data-rmh-catalog]').textContent));
    let next=root.dataset.next,pages=0;
    while(next&&pages++<20){
      const url=new URL(next,location.origin);
      if(url.origin!==location.origin)throw Error('Invalid catalog URL');
      url.searchParams.set('section_id',root.dataset.sectionId);
      const response=await fetch(url,{credentials:'same-origin',signal:AbortSignal.timeout(20000)});
      if(!response.ok)throw Error('Catalog unavailable');
      const page=new DOMParser().parseFromString(await response.text(),'text/html').querySelector('#rm-design-home');
      if(!page)throw Error('Missing catalog');
      add(JSON.parse(page.querySelector('[data-rmh-catalog]').textContent));next=page.dataset.next;
    }
    cycle=Array.from(wall.children);extendWall();
  }catch{loaded=false;}
}
trigger.addEventListener('click',event=>{
  event.preventDefault();
  if(!dialog){
    dialog=document.createElement('dialog');dialog.id='rm-wall-dialog';dialog.setAttribute('aria-label',"Wall o’ Tees");
    const close=document.createElement('button');close.type='button';close.className='rm-wall-close';close.setAttribute('aria-label','Close tee wall');close.textContent='×';close.autofocus=true;close.addEventListener('click',()=>dialog.close());
    wall=document.createElement('div');wall.className='rm-wall-inner';
    dialog.append(close,wall);document.getElementById('MainContent').append(dialog);
    dialog.addEventListener('scroll',extendWall,{passive:true});
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
    dialog.addEventListener('close',()=>{document.body.style.overflow=previousOverflow;trigger.focus();});
  }
  previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal();load();extendWall();
});
})();

